<template>
  <div class="record-form">
    <p class="record-count">共进行了4个环节的内容确认，上传了{{uploadFileCount}}个相关文件,进行了{{manualEditCount}}次的手动编辑和{{aiEditCount}}次的AI编辑.</p>
    <el-timeline class="record-timeline">
      <el-timeline-item v-for="item in recordList" :key="item.id" :timestamp="item.createTime" placement="top">
        <h4>{{item.description}}</h4>
      </el-timeline-item>
    </el-timeline>
  </div>
  </template>
  <style scoped>
    .record-form {
      height: 200px;
      overflow: auto;
      border-top: 1px solid #e4e7ed;
      padding-top: 10px;
    }
    .record-count {
      font-size: 12px;
      color: #999999;
      padding:  10px;
    }
    .record-timeline {
      padding: 10px;
    }
  </style>
  <script setup>
import { ref, nextTick } from 'vue';
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  
})
import { watch } from 'vue'

const recordList = ref([])
const uploadFileCount = ref(0)
const manualEditCount = ref(0)
const aiEditCount = ref(0)
watch(() => props.modelValue, (newVal) => {
  console.log('newVal', newVal)
  recordList.value = newVal?.records || []
  uploadFileCount.value = newVal?.uploadFileCount || 0
  manualEditCount.value = newVal?.manualEditCount || 0
  aiEditCount.value = newVal?.aiEditCount || 0
}, { immediate: true })
</script>

